import wcs from '@/scripts/libs/wcs'
import axios from 'axios'

import AlgoliaAnalytics from '@/scripts/libs/algolia/analytics'
import { PlpColor } from '@/types/plp'
import { Product } from '@/types/pdp'
import { AlgoliaTracking } from '@/scripts/libs/algolia/types/analytics'

import makeDebug from 'debug'
import {
  ALGOLIA_LANDING_PDP_TEALIUM_ACCOUNT,
  ALGOLIA_LANDING_PDP_TEALIUM_DATASOURCE,
  ALGOLIA_LANDING_PDP_TEALIUM_EVENT,
  ALGOLIA_LANDING_PDP_TEALIUM_PROFILE,
} from '@/scripts/constants/tracker'
const debug = makeDebug('Analytics')

class AnalyticsHelper {
  trackMouseHover(product: PlpColor) {
    const { searchProvider } = wcs.getStoreConfig()

    if (searchProvider === 'algolia' && product?.algoliaTracking) {
      AlgoliaAnalytics.trackMouseHover(product.algoliaTracking)
    }
  }

  trackMouseClick(product: PlpColor) {
    const { searchProvider } = wcs.getStoreConfig()

    if (searchProvider === 'algolia') {
      this.saveAnalyticsDataInStorage(product)
    }
  }

  saveAnalyticsDataInStorage(product: PlpColor) {
    const { partNumber, algoliaTracking: algolia } = product

    const data = {
      partNumber: partNumber,
      algolia: algolia,
    }

    localStorage.setItem('algoliaTracking', JSON.stringify(data))
  }

  trackAddToBag(product: Product) {
    const { searchProvider } = wcs.getStoreConfig()

    if (searchProvider === 'algolia') {
      const dataInStorage = localStorage.getItem('algoliaTracking')

      if (dataInStorage) {
        const data = JSON.parse(dataInStorage)

        const { partNumber, algolia } = data

        if (partNumber === product.partNumber && algolia) {
          AlgoliaAnalytics.trackAddToBag(algolia, product.partNumber)
        }
      }
    }
  }

  trackLandingPdp(product: Product) {
    const { searchProvider } = wcs.getStoreConfig()

    if (searchProvider === 'algolia') {
      const dataInStorage = localStorage.getItem('algoliaTracking')

      if (dataInStorage) {
        const data = JSON.parse(dataInStorage) as { partNumber: string; algolia: AlgoliaTracking }

        const { partNumber, algolia } = data

        if (partNumber === product.partNumber && !!algolia) {
          const endpoint = 'https://collect.tealiumiq.com/event'
          const groupedPosition = algolia.grouped.position ?? 0
          const ungroupedPosition = algolia.ungrouped.position ?? 0
          const objectID = algolia.ungrouped.objectIDs
            ? algolia.ungrouped.objectIDs[ungroupedPosition]
            : algolia.grouped.objectIDs && algolia.grouped.objectIDs[groupedPosition]

          const ungroupedPositionParam = (ungroupedPosition + 1).toString()
          const groupedPositionParam = (groupedPosition + 1).toString()

          const params = {
            tealium_account: ALGOLIA_LANDING_PDP_TEALIUM_ACCOUNT,
            tealium_profile: ALGOLIA_LANDING_PDP_TEALIUM_PROFILE,
            tealium_datasource: ALGOLIA_LANDING_PDP_TEALIUM_DATASOURCE,
            tealium_event: ALGOLIA_LANDING_PDP_TEALIUM_EVENT,
            grouped_queryID: algolia.grouped.queryID,
            ungrouped_queryID: algolia.ungrouped.queryID,
            grouped_indexName: algolia.grouped.indexName,
            ungrouped_indexName: algolia.ungrouped.indexName,
            grouped_position: groupedPositionParam,
            ungrouped_position: ungroupedPositionParam,
            userToken: AlgoliaAnalytics.getUserToken(),
            objectIDs: [objectID],
          }

          try {
            axios.post(endpoint, params)
          } catch (error) {
            debug('trackLandingPdp', error)
          }
        }
      }
    }
  }
}

export default new AnalyticsHelper()
